import { useEffect, useRef, useState } from "react";
import { Upload, Trash2, Copy } from "lucide-react";
import api, { mediaUrl, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminMedia() {
  const [media, setMedia] = useState([]);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();
  const load = () => api.get("/admin/media").then(({ data }) => setMedia(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = [...e.target.files];
    setBusy(true);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try { await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); }
      catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    }
    setBusy(false);
    toast.success("Geüpload");
    load();
  };
  const del = async (id) => { await api.delete(`/admin/media/${id}`); load(); };
  const copy = (url) => { navigator.clipboard.writeText(mediaUrl(url)); toast.success("URL gekopieerd"); };

  return (
    <div data-testid="admin-media">
      <div className="flex items-center justify-between mb-6">
        <h1 className="heading-x text-2xl">MEDIABIBLIOTHEEK</h1>
        <button onClick={() => fileRef.current.click()} disabled={busy} className="btn-x text-[0.65rem]" data-testid="upload-media-btn"><Upload size={14} /> {busy ? "UPLOADEN…" : "UPLOAD"}</button>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/avif" multiple hidden onChange={upload} data-testid="media-file-input" />
      </div>
      <p className="label-x mb-4">JPG · PNG · WEBP · AVIF — MAX 12MB. Klik op een afbeelding om de URL te kopiëren voor gebruik in producten/CMS.</p>
      <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
        {media.map((m) => (
          <div key={m.id} className="group relative aspect-square bg-[#E8E1D8] overflow-hidden border border-[#E8E1D8]" data-testid={`media-${m.id}`}>
            <img src={mediaUrl(m.url)} alt={m.alt_text} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#1D1D1B]/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
              <button onClick={() => copy(m.url)} className="text-[#F7F5F1]"><Copy size={16} /></button>
              <button onClick={() => del(m.id)} className="text-[#F7F5F1]"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
        {media.length === 0 && <p className="label-x col-span-full py-10 text-center">NOG GEEN MEDIA</p>}
      </div>
    </div>
  );
}
